import { Box } from '@chakra-ui/react';
import ContentLoader from 'react-content-loader';

const CandidateLoading = () => {
  return (
    <Box py="10px">
      <ContentLoader speed={2} width={300} height={40} viewBox="0 0 300 40">
        <circle cx="18" cy="18" r="18" />
        <rect x="50" y="5" rx="3" ry="3" width="200" height="10" />
        <rect x="50" y="23" rx="3" ry="3" width="100" height="10" />
      </ContentLoader>
    </Box>
  );
};

export const JobLoading = () => {
  return (
    <Box mb="12px" maxH="140px">
      <ContentLoader speed={2} width={300} height={140} viewBox="0 0 300 140">
        <rect x="0" y="0" rx="3" ry="3" width="250" height="10" />
        <rect x="0" y="24" rx="3" ry="3" width="200" height="10" />
        <rect x="0" y="70" rx="3" ry="3" width="150" height="10" />
        <rect x="0" y="94" rx="3" ry="3" width="150" height="10" />
      </ContentLoader>
    </Box>
  );
};

export const Loading = ({ size = 6 }) => {
  return (
    <Box>
      {Array(size)
        .fill(0)
        .map((_, idx) => (
          <CandidateLoading key={idx} />
        ))}
    </Box>
  );
};
